import { Row, Col, Table } from "react-bootstrap";
import {
    DatatableWrapper,
    TableHeader,
    TableBody,
    Pagination,
    PaginationOptions
} from "react-bs-datatable";

const LeavesTableSection = ({
    title,
    tooltip,
    searchValue,
    onSearchChange,
    headers,
    body,
    labels,
    rowsPerPageOptions = [5, 10, 15, 20, 25, 30]
}) => {
    return (

        <Row className="justify-content-center ">
            <Col lg={10} style={{ paddingBottom: "10px" }}>
                {/* Search */}
                <Row className="d-flex mb-3 justify-content-end">
                    <Col xs={4}>
                        <div className="input-group">
                            <span className="input-group-text bg-white">
                                <i className="fa fa-search"></i>
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search leaves..."
                                value={searchValue}
                                onChange={(e) => onSearchChange(e.target.value)}
                            />
                        </div>
                    </Col>
                </Row>

                {/* Title */}
                <h5 className="mb-3 d-flex align-items-center gap-2">
                    {title}
                    <i
                        className="fa fa-info-circle text-secondary"
                        data-bs-toggle="tooltip"
                        data-bs-placement="right"
                        title={tooltip}
                        style={{ cursor: "pointer" }}
                    ></i> &nbsp;
                    ({body.length})
                </h5>

                {/* Table */}
                <DatatableWrapper
                    headers={headers}
                    body={body}
                    sortProps={{
                        initialState: {
                            sortBy: []  
                        }
                    }}
                    paginationOptionsProps={{
                        initialState: {
                            rowsPerPage: rowsPerPageOptions[0],
                            options: rowsPerPageOptions
                        }
                    }}

                    isFilterable={false}
                    isSortable={true}

                >
                    <Table striped className="data-table">
                        <TableHeader />
                        <TableBody />
                    </Table>

                    <Row>
                        <Col lg={6} xs={12} className="d-flex align-items-center justify-content-start">
                            <span className="me-2 mt-2">Show</span>
                            <PaginationOptions labels={labels} />
                            <div className="mt-2 mx-2">Records</div>
                        </Col>

                        <Col lg={6} xs={12} className="d-flex align-items-center justify-content-end">
                            <div className="text-end mb-1 mt-3">
                                <Pagination />
                            </div>
                        </Col>
                    </Row>
                </DatatableWrapper>

            </Col>
        </Row>
    );
};

export default LeavesTableSection;
